import { Component, ElementRef, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, EventEmitter, AfterViewChecked } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { of as observableOf, Observable, of, Subscription, throwError } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { files } from '../../../_models/example-data';
import { ProjectService } from '../../../_services/project.service';
import { TestService } from '../../../_services/test.service';
import { ToastrService } from 'ngx-toastr';
import { beatBlipSubscriptionConsts } from '../../../consts/beatBlipSubscriptionConsts';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, ControlContainer, Validators, FormControl, FormArray, AbstractControl, UntypedFormArray,UntypedFormControl } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, find, switchMap } from 'rxjs/operators';
import { UserMgmtService } from '../../../_services/user-mgmt.service';
import { UserService } from '../../../_services/user.service';
import { UserRestrictions } from '../../../_models/userRestriction';
import { UserTab } from '../../../_models/UserTab';
import { ProjectData } from 'src/app/_models/project-data';
import { Pipe, PipeTransform } from '@angular/core';
import { jsPlumb } from 'jsplumb';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import * as _ from "lodash";
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { SettingService } from 'src/app/_services/setting.service';
import { ConfirmationDialogService } from '../confirmation-dialog.service';
import { indexOf } from 'lodash';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MemoryService } from 'src/app/_services/memory.service';
import { SpinnerService } from 'src/app/_services/spinner.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RedactionService } from 'src/app/_services/redaction.service';

@Component({
  selector: 'app-step-form',
  templateUrl: './step-form.component.html',
  styleUrls: ['./step-form.component.scss']
})
export class StepFormComponent implements OnInit, AfterViewChecked {
  manageParamOptions = ["","Text", "Global Variable", "Function"];//, "Function"
  manageParamOptions2 = ["Bugzilla", "GitLab", "Jira", "TFS", "TFS_PAT"];
  bugzilla = ["bugzilla_password", "bugzilla_url", "bugzilla_username", "type"];
  // bugZillaObjectForUpdate=[{"key":"bugzilla_password","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_url","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_username","value":"","$$hashKey":"object:6459"},{"key":"type","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_password","value":"","$$hashKey":"object:6459"}]
  gitlab = ["gitlab_password", "gitlab_project", "gitlab_project_namespace", "gitlab_url", "gitlab_username"];
  jira = ["jira_password", "jira_project", "jira_url", "jira_userName"];
  tfs = ["tfs_metadata", "tfs_password", "tfs_project", "tfs_url", "tfs_username"];
  tfsPAT = ["tfs_metadata", "tfs_password", "tfs_project", "tfs_url", "tfs_username"];
  keys = ["NULL", "CANCEL", "HELP", "BACKSPACE", "TAB", "CLEAR", "RETURN", "ENTER", "SHIFT", "LEFT_SHIFT", "CONTROL", "LEFT_CONTROL", "ALT", "LEFT_ALT"
    , "PAUSE", "ESCAPE", "SPACE", "PAGE_UP", "PAGE_DOWN", "END", "HOME", "LEFT", "ARROW_LEFT", "UP", "ARROW_UP", "RIGHT", "ARROW_RIGHT", "DOWN"
    , "ARROW_DOWN", "INSERT", "DELETE", "SEMICOLON", "EQUALS", "F1", "F2", "F3", "F4", "F5", "F6"];


  showDiv = {
    previous: false,
    current: false,
    next: false
  }
  value = 'Clear me';
  locatorData: any = [];
  // value: any;
  selectedValue: any;
  bugValue: any;
  keyValue: any;
  valuechanged: boolean = false;
  selectedfValue: any;
  functions = [] as any;
  actions = [] as any;
  fieldlist: any;
  methodname: any;
  defaultValues: [];
  projectId: any;
  testId: any;
  testStepId: any;
  url: string;
  getProjectByIdData: Object;
  globalVariable: any;
  selectedFunctionValues: any;
  selectedGvar: any;
  invokeStep = false;
  stepIndex: any;
  testStepdata: any;
  testStep: any[] = [];
  arr: any;
  contentDiv = [{
    "parameterType": undefined,
    "parameterValue": undefined
  }];
  testStepIndex: any;
  testStepAtSelectedIndex: any;
  selectedAction: any;
  selectedScreen: any;
  startHighlightLocator = '';
  startHighlightRow = '';
  startHighlightColumn = '';
  private startHighlightLoadedIndex = -1;
  menuClickLocator = '';
  menuClickPath = '';
  private menuClickLoadedIndex = -1;
  moveHighlightLocator = '';
  moveHighlightCurrentRow = '';
  moveHighlightCurrentColumn = '';
  moveHighlightVertical = 'NONE';
  moveHighlightVerticalCount = '1';
  moveHighlightHorizontal = 'NONE';
  moveHighlightHorizontalCount = '1';
  private moveHighlightLoadedIndex = -1;
  readonly moveHighlightVerticalOptions = [
    { value: 'NONE', label: 'No change' },
    { value: 'DOWN', label: 'Move down' },
    { value: 'UP', label: 'Move up' },
    { value: 'FIRST_ROW', label: 'Move to first row' },
    { value: 'LAST_ROW', label: 'Move to last row' }
  ];
  readonly moveHighlightHorizontalOptions = [
    { value: 'NONE', label: 'No change' },
    { value: 'FIRST_COLUMN', label: 'Move to first column' },
    { value: 'RIGHT', label: 'Move right' },
    { value: 'LEFT', label: 'Move left' },
    { value: 'LAST_COLUMN', label: 'Move to last column' }
  ];
  elementKeyData: any;
  elementEntryKeyData: any;
  visibleFieldValue: any;
  Vfeild: any[];
  hide: boolean = true;
  parentId: any;
  index: any;
  projectData: any;
  projectType: any;

  // new variables
  currentTab: number = 0;
  showElementKeyContnent: boolean = false;
  editLocatorTitleForm: UntypedFormGroup;
  enableSubmit: boolean = false;
  screenName: string = ''; // not required
  addLocatorsForm: UntypedFormGroup;
  disableButton: boolean = true;
  addLocator: boolean = false;
  keyForinsertComment: any;
  valueForInsert: any;
  locatorEntryCommentValue: any;
  valueForUpdate = '';

  locatorEntryMapValue: any;
  locatorValueData: any;
  locatorId: any;
  subscription: Subscription;
  updateLocatorValues: boolean = false;
  locatorValueIndex: any;

  formclicked: boolean = false;
  rawclicked: boolean = true;
  selectedKeys = [];
  selectedKeys1 = [];
  selectedKeys2 = [];
  keyValueFunctions = ["extraction","redaction","filehandle", "pdfHandle", "dataCompare", "getJsonValue", "sqlDump", "getXmlValue", "ntlmtoken", "oauthtoken", "jsonCompare", "deletefile", "verifytext", "watchfile", "copyfile", "loadcsv", "couchbasesql", "filevalidate", "loadtestData", "wordEmbedded", "pdfmerge", "getCellReference", "setCellReference", "loadExcelTable", "excelHandle","runCmdProcess","csvvalidate","getColumnSumExcel","csvHandle","date"];

  myForm: UntypedFormGroup;
  disabled = false;
  showFilter = false;
  limitSelection = false;
  dropdownList: any[] = [];
  extractionList: any[] = [];
  redactionList: any[] = [];
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',           // Match this with your data structure
    textField: 'name',       // Match this with your data structure
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  userEmail: string;
  groupDetails: any;
  extractionTerms: any;
  redactionTerms: any;
  isER: boolean = false;
  extractionTermsCopy: any;
  redactionTermsCopy: any;
  erUrl: any = "";
  cities: any = [];
  selectedItems: any = [];
  dropdownSettings: any = {};
  allTestCaseData: any;
  path: any;
  filterAllTesCaseData: any;
  selectedCase: any;
  moduleName: any;
  selectedCaseId: string;
  settingData: any;
  testEnvData: any;
  parameterForLogData: any;
  userForm: UntypedFormGroup;
  tabVal: any = 1;
  stepsTobeDelete: any;
  initiateDelTestStep: any[];
  moduleName1: any;
  optionSelected = [];
  functionName: any;
  selectedFunction: any;
  selectedTestCase: any='';
  functionDataForUpdate: any;
  globalVariableForUpdate: any;
  selectedGlobalVar: any;
  parameterValueForUpdate: any;
  textParameter: any;
  eventwithoutSpace: any;
  enableTextField: boolean;
  currentFunction: any;
  functionMethodNames = {};
  pathCheck: any;
  suiteData: Object;
  id: any;
  buttonAction: any;
  functionDescription: any;
  actionDescription: any;
  isDynamic :boolean = false;
  selectedSubfunction: any;
  subFunctionObject: any;
  actionsMetaData: any=[];
  groupedActionData: any;
  passFunctionParam: any;
  showPopUp: boolean =false;
  pseAction: any;
  agentCheck: boolean;
  allBranches: any;
  form: UntypedFormGroup;
  selectedBranches: any;
  locatorCommentMap: any;
  selectedPseCommands: any;
  spinerFlag: boolean;
  selectedScreenName: string;
  preConditionCommand: any;
  constructor(
    private redactionService: RedactionService,
    private testCase: TestService,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private cookieService: CookieService,
    private http: HttpClient,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private usermgmt: UserMgmtService,
    private location: Location,
    private router: Router,
    private setting: SettingService,
    private spinnerService: SpinnerService,
    private confirmationDialogService: ConfirmationDialogService,
    private memoryService:MemoryService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<StepFormComponent>,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    this.url = environment.baseUrl;
    this.index = data.message.index;
    this.parentId = data.message.parentId;
    this.projectId = data.message.projectId;
    this.testStepId = data.message.testStepId;
    this.pseAction = data.message.pseCommand;
    this.path = data.moduleName;
    this.pathCheck = data.CheckCall;
   
    this.buttonAction=data.buttonIdentifier;
    if(this.pathCheck=='pre-condition' && this.buttonAction=='Add')
      {
        this.pseAction = 'Open Web Browser';
      }
      //this.actionsMetaData[this.selectedAction]
      
    this.id = data.message.id;
    this.moduleName1 = this.path;
    this.moduleName1 = this.moduleName1.split(',');
    // this.functions=JSON.parse(localStorage.getItem('functions'));
    //console.log(this.path);
    //console.log(data);
    //console.log('FunctionNameFromFlowChart', data.message.functionName);
    if (data.message.functionName) {
      // this.formButton.nativeElement.click();
      // this.getGroupedAction();
      this.optionSelected.push('Function');
      this.functionName = data.message.functionName;
      var fName = this.functionName.split(',')
      this.selectedFunction = fName[0];
      this.passFunctionParam = fName[1];
      if(data.message.subFunction){
        console.log(data.message.subFunction);
        this.subFunctionObject = data.message.subFunction;
        this.selectedSubfunction = this.subFunctionObject.subname;
      //  ${__pdfHandle(action=contains,fPath=ashu67,text=asu33,start=0,end=1)}
       var stringForSubFunction = '${__' + this.subFunctionObject.children['method'] + this.selectedSubfunction+'('+ ')}'
       console.log(stringForSubFunction);
       console.log(this.subFunctionObject.children);
      //  this.segregateParameters(stringForSubFunction);
       
      }
    }
    this.userForm = this.formBuilder.group({
      name: [],
      phones: this.formBuilder.array([
        this.formBuilder.control(null)
      ])
    })
    if(JSON.parse(localStorage.getItem('projectDataById'))){
      var res = JSON.parse(localStorage.getItem('projectDataById'));
      this.projectData = res;
        //console.log(this.projectData);
        this.projectType = this.projectData.projectType;
        // this.getActions();
      
    }
    else{
      this.project.getProjectById(this.projectId).subscribe((
        data => {
          this.projectData = data;
          //console.log(this.projectData);
          this.projectType = this.projectData.projectType;
          // this.getActions();
          // this.getIncludedTestCases(this.projectId);
        }
      ))
    }
 

  }
  ngAfterViewChecked(): void {
    this.ensureStartHighlightLoaded();
    this.ensureMenuClickLoaded();
    this.ensureMoveHighlightLoaded();
  }
  ngAfterViewInit() {

    setTimeout(() => {
      if (this.functionName) {
        //console.log('afterView');
        this.formButton.nativeElement.click();

        this.selectBox.nativeElement.click();
        this.selectChangeHandler('Function', 0);
        // this.selectFunction.nativeElement.click();
        // var selectedFunctionFromDrag = this.functions.find((f)=>f.name=this.selectedFunction);
        // this.selectedFunction = selectedFunctionFromDrag.pseFunction;
        this.selectfunctionHandler(this.passFunctionParam, 0);
        if(this.subFunctionObject){
          setTimeout(() => {
            this.selectDvDropdown.nativeElement.click();
            // document.getElementById('selectDvDropdown').value = "value";
            this.onChangeFunctionDropdown(this.selectedSubfunction, this.currentFunction.fieldList[0].name,true,0)
            console.log(this.contentDiv[0]['fieldlist']);
            // ${__pdfHandle(action=contains,fPath=ashu67,text=asu33,start=0,end=1)
            var varResult = []
            this.contentDiv[0]['fieldlist'].forEach(data1 => {
                 console.log(data1);
                 if(data1.type=='dropdown' && data1.isFieldDecideable==true){
                  data1.value=this.selectedSubfunction;
                 }
              let varResult1 = data1.value;
              let result1 = data1.name + "=" + data1.value;
              varResult.push(result1);
            });
            console.log(varResult);
            let finalValue = varResult.join();
              var   paramName = '${__' + this.contentDiv[0]['methodname'] + '(' + finalValue + ')}';
              console.log(paramName);
              
          }, 1000);
         
        }

      }
    }, 1000);



  }
  test() {
    //console.log('clicked');

  }
  addParameter() {
    this.contentDiv.push({
      "parameterType": undefined,
      "parameterValue": undefined
    });
  }
  removeDiv(contentIndex) {
    this.contentDiv.splice(contentIndex, 1);
  }

  @ViewChildren("bugButton") bugButton: ElementRef;

  @ViewChild("formButton") formButton: ElementRef;

  @ViewChild("selectBox") selectBox: ElementRef;
  
  @ViewChild("selectDvDropdown") selectDvDropdown: ElementRef;
  @ViewChild("selectFunction") selectFunction: ElementRef;
  //selectFunction
  //  @ViewChildren("selectFunction") selectFunction: QueryList<ElementRef>;
  // closeDialog() {
  //   this.dialogRef.close(false);
  // }
  selectChangeHandler(event: any, index) {
    //console.log(index);

    this.contentDiv[index].parameterType = event;
    this.selectedValue = event;
  }
  selectBugHandler(event: any) {
    this.bugValue = event.target.value;
    if (this.bugValue === 'Bugzilla') {
      this.bugzilla = this.bugzilla
    }
    if (this.bugValue === 'GitLab') {
      this.bugzilla = this.gitlab
    }
    if (this.bugValue === 'Jira') {
      this.bugzilla = this.jira;
    }
    if (this.bugValue === 'TFS') {
      this.bugzilla = this.tfs
    }
    if (this.bugValue === 'TFS_PAT') {
      this.bugzilla = this.tfsPAT;
    }
  }
  //   firterBugLogData(bug){
  // var filterdBug = this.settingData.filter((f)=>)
  //   }
  selectkeyHandler(event: any) {
    this.keyValue = event.target.value;
  }

  onRawClick() {
    if (this.rawclicked == false) {
      this.showDiv.previous = !this.showDiv.previous;
      this.showDiv.current = false;
      this.showDiv.next = false;
      this.rawclicked = true;
      this.formclicked = false;
    }
  }

  onFormClick() {
    if (this.formclicked == false) {
      this.showDiv.current = !this.showDiv.current;
      this.showDiv.previous = true;
      this.showDiv.next = false;
      this.rawclicked = false;
      this.formclicked = true;
    }

    var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    console.log(this.testStep[this.testStepIndex - 1].parameters['settingValue']);
    this.segregateParameters(this.testStep[this.testStepIndex - 1].parameters['settingValue']);
    
    if (this.testStep[this.testStepIndex - 1].parameters['settingValue'].includes('{')) {
      this.parameterValueForUpdate = this.testStep[this.testStepIndex - 1].parameters['settingValue'].split('}');

      //console.log(this.parameterValueForUpdate);
      var indexCheck: boolean = false;
      var funCheck: boolean = false;
      for (let i = 0; i < this.parameterValueForUpdate.length; i++) {
        if (this.parameterValueForUpdate.length > 1) {

          if (this.parameterValueForUpdate[i].includes('${_')) {
            funCheck = true;
            if (indexCheck) {
              this.addParameter();
            }
            if (this.enableTextField) {
              this.addParameter();
            }
            //  //console.log('Function',this.testStep[this.testStepIndex-1].parameters);
            //  //console.log(this.functions);
            // var methodNameForEdit = this.parameterValueForUpdate[i].slice(this.parameterValueForUpdate[i].indexOf('_') + 2, this.parameterValueForUpdate[i].indexOf('('))
            // this.functionDataForUpdate = this.parameterValueForUpdate[i].slice(this.parameterValueForUpdate[i].indexOf('(')+1,this.parameterValueForUpdate[i].indexOf(')'))
            // //console.log(this.functionDataForUpdate);
            // this.functionDataForUpdate=this.functionDataForUpdate.split(',')
            // //console.log('methodNameForEdit', methodNameForEdit);
            // //console.log(this.functionDataForUpdate);
            // //console.log(this.functions);

            // var selectedFunction = this.functions.filter((f) => f.method === methodNameForEdit)
            // this.optionSelected.push('Function');
            // //console.log('selectedFunction', selectedFunction);

            // this.selectBox.nativeElement.click();
            // this.selectChangeHandler('Function', i);
            // this.selectedFunction = selectedFunction[0].name;
            // this.selectfunctionHandler(this.selectedFunction, i);
            //   //console.log(this.functionDataForUpdate);
            //   //console.log(this.contentDiv.length);

            //   //console.log(this.contentDiv[this.contentDiv.length-1]['fieldlist']);

            // //console.log(this.contentDiv[this.contentDiv.length-1]['methodname']);
            // //console.log(this.contentDiv[this.contentDiv.length-1]['fieldlist']);
            // //console.log(this.contentDiv[this.contentDiv.length-1]['methodname']);
            // //console.log(this.contentDiv[0]['fieldlist']);

            for (let j = 0; j < this.functionDataForUpdate.length; j++) {
              this.contentDiv[0]['fieldlist'][j]['value'] = this.functionDataForUpdate[j]
              // if (this.contentDiv[this.contentDiv.length - 1]['fieldlist'][0].type == 'dropdown') {
              //   if (j == 0) {
              //     //console.log(this.functionDataForUpdate);
              //     //console.log(this.contentDiv[this.contentDiv.length - 1]['fieldlist'][0]);
              //     this.selectfunctionValues(this.functionDataForUpdate[j], this.contentDiv.length - 1);
              //   }

              //   this.contentDiv[this.contentDiv.length - 1]['result2'][j] = this.functionDataForUpdate[j + 1];
              // }
              // else if (this.contentDiv[this.contentDiv.length - 1]['fieldlist'][j].type == 'text') {
              //   this.contentDiv[this.contentDiv.length - 1]['result1'][j] = this.functionDataForUpdate[j]
              // }
            }




            //     for(let j=0; j< this.contentDiv[this.contentDiv.length-1]['fieldlist'].length;j++){
            //  if( this.contentDiv[this.contentDiv.length-1]['fieldlist'][j].type=='dropdown'){
            //    //console.log(this.contentDiv[this.contentDiv.length-1]['fieldlist'][j].name);
            //    this.selectfunctionValues(this.functionDataForUpdate[j],this.contentDiv.length-1)
            //  }
            // }
            //     }
            //       for(let k=0; k< this.functionDataForUpdate.length;k++){
            //         if(this.functionDataForUpdate.length<1){
            //           this.contentDiv[k]['result1'][k]=this.functionDataForUpdate[k];
            //           //console.log(this.contentDiv[k]['result1'][k]);

            //         }
            //         else{

            //           this.contentDiv[0]['result1'][i]=this.functionDataForUpdate[i];
            //         }

            //       }

          }
          //|| !this.parameterValueForUpdate[i].includes('$G{')




          //  if(this.parameterValueForUpdate[i]=''){
          // return;
          //  }

          // else if(format.test(this.parameterValueForUpdate[i])==false){
          //   //console.log(this.parameterValueForUpdate[i]);

          //   //console.log(format.test(this.parameterValueForUpdate[i]));

          //   this.addParameter();
          //   this.optionSelected.push('Text');
          //   this.selectChangeHandler('Text',i);
          //   this.textParameter = this.parameterValueForUpdate[i]
          //   this.contentDiv[i].parameterValue = this.textParameter;
          // }
        }

      }

    }
    else{

            if (funCheck) {
              this.addParameter();
            }
            if (indexCheck) {
              this.addParameter();
            }
            this.enableTextField = true;
            this.optionSelected.push('Text');
            this.selectChangeHandler('Text', 0);
            this.textParameter = this.testStep[this.testStepIndex - 1].parameters['settingValue'];
            this.contentDiv[0].parameterValue = this.textParameter;
    }
  }
  segregateParameters = function (input) {
    var paramValue = input;
    var func = "${__";
    var globalVar = "$G{";
    var localeVar = "$L{";
    var suiteVar = "$S{";
    var localVar = "${";
    var endVar = "}";
    var endFunc = ")}";
    var n = 0;
    var showDropdown = false;
    var parametersFormsSequence = new Array();
    var groups = {};
    groups[func] = endFunc;
    groups[globalVar] = endVar;
    groups[localeVar] = endVar;
    groups[suiteVar] = endVar;
    groups[localVar] = endVar;

    var arguments1 = {};
    var argumentIndex = 0;
    var increaseArgIndex = false;

    for (var i = 0; i < paramValue.length; i++) {
      if (paramValue.charAt(i) === '$') {
        if (func === paramValue.substring(i, i + 4)) {
          argumentIndex++;
          n = paramValue.indexOf(endFunc, i);
          arguments1[argumentIndex] = {};
          parametersFormsSequence.push(arguments1[argumentIndex]);
          //console.log(parametersFormsSequence);

          arguments1[argumentIndex].name = paramValue.substring(i + 4, paramValue.indexOf("(", i));
          arguments1[argumentIndex].type = "Function";
          // arguments1[argumentIndex].form =this.evaluateParamTemplate({type: arguments[argumentIndex].name});
          arguments1[argumentIndex].data1 = (paramValue.substring(i, n + 2));
          arguments1[argumentIndex].args = (arguments1[argumentIndex].data1.substring(arguments1[argumentIndex].data1.indexOf("(") + 1, arguments1[argumentIndex].data1.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //console.log('Args', arguments1[argumentIndex].args);
          //console.log('name', arguments1[argumentIndex].name);
          var selectedFunction = this.functions.filter((f) => f.method ===  arguments1[argumentIndex].name)
          if(selectedFunction[0].name=='SQL' || selectedFunction[0].name=='SQLSP'){
            var tempArg = arguments1[argumentIndex].args
            var tempString = tempArg.slice(1,tempArg.length).join()
                arguments1[argumentIndex].args.splice(1, 0, tempString);
          }
          
            this.optionSelected.push('Function');
            // //console.log('selectedFunction', selectedFunction);

            this.selectBox.nativeElement.click();
            this.selectChangeHandler('Function', 0);
            this.selectedFunction = selectedFunction[0].pseFunction;
            this.selectfunctionHandler(selectedFunction[0].name, 0);
            this.functionDataForUpdate = arguments1[argumentIndex].args;
         //console.log(this.functionDataForUpdate);

         if (this.checkIfFunctionMethodNameExist(arguments1[argumentIndex].name) && n >= 0) {
          if (this.keyValueFunctions.includes(arguments1[1].name) || this.currentFunction.isKeyValueFunction) {
              var value = '';
              var activeFieldList = new Array();
              for (var k = 0; k < this.currentFunction.fieldList.length; k++) {
                  if (this.currentFunction.fieldList[k].isVisible == true) {
                      activeFieldList.push(this.currentFunction.fieldList[k]);
                  }
              }
              for (var j = 0; j < arguments1[argumentIndex].args.length; j++) {
                  var data = arguments1[argumentIndex].args[j].split(/=(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                  if (j === 0) {
                      value = data[1];
                      // this.contentDiv[0]['fieldlist'][j]['value']=data[1];
                      //console.log(this.contentDiv[0]);

                  }
                  if (activeFieldList.length > j) {
                      var matchingField = this.getFuntionField1(activeFieldList, data[0]);
                      /**
                       * If field is drop down then we will be adding all the dependent fields on the matching active field list.
                       */
                      if (matchingField && matchingField.type === 'dropdown') {
                          var matchingValues = this.getMatchingValues(this.getMatchingFields(this.currentFunction.fieldList, data[0]), data[1]);
                          for (var k = 0; k < matchingValues.length; k++) {
                              if (!this.getFuntionField1(activeFieldList, matchingValues[k].name)) {
                                  activeFieldList.push(matchingValues[k]);
                              }
                          //console.log(activeFieldList);

                          }
                      }
                      arguments1[argumentIndex].args[j] = data[1];
                      //console.log(arguments1[argumentIndex]);

                      // this.contentDiv[0]['fieldlist'][j]['value']=data[1];
                  } else if (this.currentFunction.variableFieldList && activeFieldList.length > 0) {
                      var fields = data[0].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                      var fieldObject = new Object();
                      for (var k = 0; k < fields.length; k++) {
                          if (fields[k] !== undefined && fields[k].length > 0) {
                              fieldObject[k] = fields[k];
                          }
                      }
                      arguments1[argumentIndex].args[j] = fieldObject;
                     //console.log(arguments1[argumentIndex]);

                  }
              }
              this.onChangeFunctionDropdown(value, this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
          } else if (arguments1[1].name === "exeexecute") {
              arguments1[argumentIndex].args = (arguments1[argumentIndex].data.substring(arguments1[argumentIndex].data1.indexOf("(") + 1, arguments1[argumentIndex].data1.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          } else {
            if(this.currentFunction.type === 'variable') {
                for(let j=this.currentFunction.fieldList.length;j<arguments1[argumentIndex].args.length;j++){
                    var fields = arguments1[argumentIndex].args[j].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                    var fieldObject = new Object();
                    for (var k = 0; k < fields.length; k++) {
                      if (fields[k] !== undefined && fields[k].length > 0) {
                                fieldObject[k] = fields[k];
                            }
                    }
                    arguments1[argumentIndex].args[j] = fieldObject;
                    // if(j>0){
                    //   this.addVariableFields(this.currentFunction.name,0,arguments1[argumentIndex].args[j][0])
                    // }
                  
                }
            }
            console.log(arguments1[argumentIndex].args);
            for(let z=1;z<arguments1[argumentIndex].args.length; z++){
              
                this.addVariableFields(this.currentFunction.name,0,arguments1[argumentIndex].args[z][0])
            
              
            }
              this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
          }

          // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/function.html';
          i = n + 1;
          increaseArgIndex = true;
      } else {
          this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name);
          arguments1[argumentIndex].name = "";
          arguments1[argumentIndex].type = "Text";
          arguments1[argumentIndex].data = (paramValue.substring(i));
          // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/text.html';
          break;
      }

//           if (this.checkIfFunctionMethodNameExist(arguments1[argumentIndex].name) && n >= 0) {
//             if (this.keyValueFunctions.includes(arguments1[1].name) || this.currentFunction.isKeyValueFunction) {
//                 var value = '';
//                 var activeFieldList = new Array();
//                 for (var k = 0; k < this.currentFunction.fieldList.length; k++) {
//                     if (this.currentFunction.fieldList[k].isVisible == true) {
//                         activeFieldList.push(this.currentFunction.fieldList[k]);
//                     }
//                 }
//                 for (var j = 0; j < arguments1[argumentIndex].args.length; j++) {
//                     var data = arguments1[argumentIndex].args[j].split(/=(?=(?:(?:[^"]*"){2})*[^"]*$)/);
//                     if (j === 0) {
//                         value = data[1];
//                         // this.contentDiv[0]['fieldlist'][j]['value']=value;
//                         //console.log(this.contentDiv[0]['fieldlist']);

//                     }
//                     if (activeFieldList.length > j) {
//                         var matchingField = this.getFuntionField1(activeFieldList, data[0]);
//                         /**
//                          * If field is drop down then we will be adding all the dependent fields on the matching active field list.
//                          */
//                         if (matchingField && matchingField.type === 'dropdown') {
//                             var matchingValues = this.getMatchingValues(this.getMatchingFields(this.currentFunction.fieldList, data[0]), data[1]);
//                             for (var k = 0; k < matchingValues.length; k++) {
//                                 if (this.getFuntionField1(activeFieldList, matchingValues[k].name)) {
//                                     activeFieldList.push(matchingValues[k]);
//                                 }

//                             }
//                         }
//                         arguments1[argumentIndex].args[j] = data[1];
//                         this.contentDiv[0]['fieldlist'][j]['value']=data[1];
//                         //console.log(this.contentDiv[0]['fieldlist']);

//                     } else if (this.currentFunction.variableFieldList && activeFieldList.length > 0) {
//                         var fields = data[0].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
//                         var fieldObject = new Object();
//                         for (var k = 0; k < fields.length; k++) {
//                             if (fields[k] !== undefined && fields[k].length > 0) {
//                                 fieldObject[k] = fields[k];
//                             }
//                         }
//                         arguments1[argumentIndex].args[j] = fieldObject;
//                     }
//                 }
//                 this.onChangeFunctionDropdown(value, this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
//             } else if (arguments1[1].name === "exeexecute") {
//                 arguments1[argumentIndex].args = (arguments1[argumentIndex].data.substring(arguments1[argumentIndex].data.indexOf("(") + 1, arguments1[argumentIndex].data.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
//             } else {
//               if(this.currentFunction.type === 'variable') {
//                   for(let j = this.currentFunction.fieldList.length;j<arguments1[argumentIndex].args.length;j++){
//                       var fields = arguments1[argumentIndex].args[j].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
//                       var fieldObject = new Object();
//                       for (var k = 0; k < fields.length; k++) {
//                         if (fields[k] !== undefined && fields[k].length > 0) {
//                                   fieldObject[k] = fields[k];
//                               }
//                       }
//                       arguments1[argumentIndex].args[j] = fieldObject;
//                   }
//               }
//                 this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
//             }
// //console.log(this.contentDiv);

//             // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/function.html';
//             i = n + 1;
//             increaseArgIndex = true;
//         }
      }
      else if (globalVar === paramValue.substring(i, i + 3)) {
        argumentIndex++;
        n = paramValue.indexOf(endVar, i);
        arguments1[argumentIndex] = {};
        parametersFormsSequence.push(arguments1[argumentIndex]);
        if (n >= 0) {
            arguments1[argumentIndex].type = "Global Variable";
            arguments1[argumentIndex].data = (paramValue.substring(i, n + 1));
            arguments1[argumentIndex].value = (paramValue.substring(i + 3, n));
            //console.log('Global,',arguments1[argumentIndex].data)
            // arguments1[argumentIndex].template = 'modules/test/partials/modal/teststep/variable.html';
            i = n;
            increaseArgIndex = true;
            this.selectChangeHandler('Global Variable', 0);
            // this.globalVariableForUpdate = this.parameterValueForUpdate[i].slice(this.parameterValueForUpdate[i].indexOf('{') + 1, this.parameterValueForUpdate[i].length);
            this.optionSelected.push('Global Variable');
            this.selectedGlobalVar = this.globalVariableForUpdate =arguments1[argumentIndex].value;
            //console.log(this.globalVariableForUpdate);
            //console.log(this.contentDiv.length, this.contentDiv);

            this.selectedGVar(this.globalVariableForUpdate, 0)
        } else {
            arguments1[argumentIndex].type = "Text";
            arguments1[argumentIndex].data = (paramValue.substring(i));
            // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/text.html';
            break;
        }

    }
      }
    }



  };


  selectfunctionHandler(event: any, index,identifier?:string) {
    console.log(event, index);
    if(event == "Extraction" || event == "Redaction"){
        this.getRedactionDetails();
    }
       if(identifier){
      var functionName = this.functions.find((f)=>f.pseFunction==event)
      this.contentDiv[index].parameterValue = functionName.name;
      this.selectedfValue = functionName.name;
     }
     else{
      this.contentDiv[index].parameterValue=event;
      this.selectedfValue = this.contentDiv[index].parameterValue;
     }
    
    // if(this.testStep[this.testStepIndex-1].parameters.includes('$')){
    //   this.contentDiv[index]['result1'][0]=this.functionDataForUpdate;
    // this.contentDiv[index]['result1']=this.contentDiv[index]['result1'];
    // }
    this.valuechanged = true;
    const funcData = this.functions.filter((f) => f.name === this.selectedfValue);
    this.currentFunction=funcData[0];
    // console.log(this.currentFunction);
    
    this.contentDiv[index]['type'] = [];
    this.contentDiv[index]['type'] = funcData[0].type;
    // this.contentDiv[index]['fieldlist'] = []
    this.contentDiv[index]['fieldlist'] = funcData[0].fieldList;
    this.currentFunction.fieldList=this.contentDiv[index]['fieldlist']
    // console.log(this.currentFunction);

    this.contentDiv[index]['methodname'] = []
    this.contentDiv[index]['methodname'] = funcData[0].method;
    this.contentDiv[index]['isKeyValueFunction'] = funcData[0].isKeyValueFunction;
      for(var i=0;i<this.contentDiv[index]['fieldlist'].length;i++){
          if(this.contentDiv[index]['fieldlist'][i].defaultValueType === 'dynamic'){
            this.getDynamicData(this.contentDiv[index]['methodname'],this.projectId,this.contentDiv[index]['fieldlist'][i]);
          }
      }



  }
  getDynamicData(methodName,projectId,field){
    this.testCase.getdynamicDropDownData(methodName,projectId).subscribe(
      (data:any)=>{

        if(!Array.isArray(data.list)){
        field.defaultValues=''
        field.defaultValues= ['',data.list];
        }
        else{
          field.defaultValues= data.list;
          field.defaultValues.unshift(' ');
        }

      }
    )
  }
  addVariableFields(selectedFunction : string, index1, value?:string)
  {

      this.functions.forEach(element => {
          if(element.name == selectedFunction)
          {
              if(element.variableFieldList)
              {
                console.log(element.variableFieldList)
                if(this.contentDiv[index1]['result4']==undefined){
                  this.contentDiv[index1]['result4']=[];
                }
                if(value){
                  element.variableFieldList[0].value=value; 
                }
                if(value==undefined){
                  element.variableFieldList[0].value=''; 
                }
               
                  let valArray =  [];

                  valArray.push(JSON.parse(JSON.stringify(element['variableFieldList'])));
                  
                  
                  this.contentDiv[index1]['result4'].push(...JSON.parse(JSON.stringify(valArray)));

                 

              }
          }
      });
console.log('result$',this.contentDiv[index1]['result4']);

  }
  deleteVField(index){
    this.contentDiv[0]['result4'].splice(index, 1);
    console.log(this.contentDiv[0]['result4']);
    
  }
  myFunction(contentIndex) {
    this.contentDiv[contentIndex]['result2'] = [];
    //console.log(contentIndex);

  }
  selectfunctionValues(event: any, index, fieldName = "", isDecidable:boolean=false) {

    if (fieldName != '') {
      //console.log("inside if")
      let obj = { name: fieldName, value: event };
      this.contentDiv[index]['result3'] = [];
      this.contentDiv[index]['result3'].push(obj);
    }
    if (event.includes(' ')) {
      //console.log(event);
      this.eventwithoutSpace = event.replace(/\s/g, "")
      event = this.eventwithoutSpace;
    }
    this.contentDiv[index]['result'] = [];
    this.contentDiv[index]['result'] = event;
    this.contentDiv[index]['result2'] = [];
    this.contentDiv[index]['parameterArg'] = event;
    this.selectedFunctionValues = event;
    //console.log(this.selectedFunctionValues);
    if(!isDecidable){
      return;
    }
    this.contentDiv[index]['Vfield'] = this.getFuntionField(this.contentDiv[index]['fieldlist'], this.selectedFunctionValues);
    // this.contentDiv[index]['Vfield'] = this.contentDiv[index]['Vfield'].filter(function (e) { return e != null; });

  }
  selectedGVar(event: any, index) {
    this.contentDiv[index].parameterValue = event;
    this.contentDiv[index].parameterValue = this.contentDiv[index].parameterValue;
    this.selectedGvar = event;
    //console.log(this.contentDiv[index].parameterValue);
  }
  selectChangeAction(event: any) {
    var selAction = this.actions.find((f)=>f.pseAction==event.target.value) ;
    this.selectedAction = selAction.name;
    // this.testStep[this.testStepIndex-1].commandName = this.selectedAction
    this.pseAction = event.target.value
    if (this.testStep?.[this.testStepIndex - 1] && selAction?.name) {
      this.testStep[this.testStepIndex - 1].commandName = selAction.name;
    }
    if (selAction?.name === 'STARTHIGHLIGHT') {
      this.loadStartHighlightSelection(this.testStep[this.testStepIndex - 1]?.parameters?.settingValue || '');
    } else if (selAction?.name === 'MENUCLICK') {
      this.loadMenuClickSelection(this.testStep[this.testStepIndex - 1]?.parameters?.settingValue || '');
    } else if (selAction?.name === 'MOVEHIGHLIGHT') {
      this.loadMoveHighlightSelection(this.testStep[this.testStepIndex - 1]?.parameters?.settingValue || '');
    }
      console.log('desc',this.actionDescription);

  }

  get isStartHighlight(): boolean {
    return this.testStep?.[this.testStepIndex - 1]?.commandName === 'STARTHIGHLIGHT';
  }

  get isMenuClick(): boolean {
    return this.testStep?.[this.testStepIndex - 1]?.commandName === 'MENUCLICK';
  }

  get isMoveHighlight(): boolean {
    return this.testStep?.[this.testStepIndex - 1]?.commandName === 'MOVEHIGHLIGHT';
  }

  get isClearHighlight(): boolean {
    return this.testStep?.[this.testStepIndex - 1]?.commandName === 'CLEARHIGHLIGHT';
  }

  get isHighlightResultField(): boolean {
    return this.isStartHighlight || this.isMoveHighlight || this.isClearHighlight || this.isMenuClick;
  }

  get showMoveVerticalCount(): boolean {
    return this.moveHighlightVertical === 'DOWN' || this.moveHighlightVertical === 'UP';
  }

  get showMoveHorizontalCount(): boolean {
    return this.moveHighlightHorizontal === 'LEFT' || this.moveHighlightHorizontal === 'RIGHT';
  }

  syncStartHighlightParams() {
    const step = this.testStep?.[this.testStepIndex - 1];
    if (!step) {
      return;
    }
    if (!step.parameters) {
      step.parameters = { settingValue: '', isMasked: false, owner: '', settingType: 'STANDARD', fieldType: '', values: [] };
    }
    step.parameters.settingValue = JSON.stringify({
      locator: this.startHighlightLocator || '',
      resolvedRow: this.startHighlightRow || '',
      resolvedColumn: this.startHighlightColumn || ''
    });
  }

  syncMenuClickParams() {
    const step = this.testStep?.[this.testStepIndex - 1];
    if (!step) {
      return;
    }
    if (!step.parameters) {
      step.parameters = { settingValue: '', isMasked: false, owner: '', settingType: 'STANDARD', fieldType: '', values: [] };
    }
    step.parameters.settingValue = JSON.stringify({
      locator: this.menuClickLocator || '',
      menuPath: this.menuClickPath || ''
    });
  }

  loadStartHighlightSelection(settingValue: string) {
    this.startHighlightLocator = '';
    this.startHighlightRow = '';
    this.startHighlightColumn = '';
    if (!settingValue || !String(settingValue).trim()) {
      return;
    }
    try {
      const saved = JSON.parse(settingValue);
      this.startHighlightLocator = saved?.locator || '';
      this.startHighlightRow = saved?.resolvedRow != null ? String(saved.resolvedRow) : '';
      this.startHighlightColumn = saved?.resolvedColumn != null ? String(saved.resolvedColumn) : '';
    } catch {
      // leave blanks
    }
  }

  private isLeakedStartHighlightJson(value: any): boolean {
    if (value == null || String(value).trim() === '') {
      return false;
    }
    try {
      const parsed = JSON.parse(String(value));
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return false;
      }
      const isStart = Object.prototype.hasOwnProperty.call(parsed, 'locator')
        && Object.prototype.hasOwnProperty.call(parsed, 'resolvedRow')
        && Object.prototype.hasOwnProperty.call(parsed, 'resolvedColumn');
      const isMenu = Object.prototype.hasOwnProperty.call(parsed, 'locator')
        && Object.prototype.hasOwnProperty.call(parsed, 'menuPath')
        && !Object.prototype.hasOwnProperty.call(parsed, 'resolvedRow');
      const isMove = Object.prototype.hasOwnProperty.call(parsed, 'locator')
        && Object.prototype.hasOwnProperty.call(parsed, 'currentRow')
        && Object.prototype.hasOwnProperty.call(parsed, 'verticalMove');
      return isStart || isMove || isMenu;
    } catch {
      return false;
    }
  }

  private ensureStartHighlightLoaded() {
    if (!this.isStartHighlight) {
      return;
    }
    if (this.startHighlightLoadedIndex === this.testStepIndex) {
      return;
    }
    this.startHighlightLoadedIndex = this.testStepIndex;
    this.loadStartHighlightSelection(this.testStep?.[this.testStepIndex - 1]?.parameters?.settingValue || '');
  }

  loadMenuClickSelection(settingValue: string) {
    this.menuClickLocator = '';
    this.menuClickPath = '';
    if (!settingValue || !String(settingValue).trim()) {
      return;
    }
    try {
      const saved = JSON.parse(settingValue);
      this.menuClickLocator = saved?.locator || '';
      this.menuClickPath = saved?.menuPath != null ? String(saved.menuPath) : '';
      if (!this.menuClickPath) {
        this.refreshMenuClickPathFromLocator();
      }
    } catch {
      // leave blanks
    }
  }

  onMenuClickLocatorChange() {
    this.refreshMenuClickPathFromLocator();
    this.syncMenuClickParams();
  }

  private refreshMenuClickPathFromLocator() {
    const derived = this.deriveMenuPathFromLocator(this.menuClickLocator);
    if (derived) {
      this.menuClickPath = derived;
    }
  }

  private deriveMenuPathFromLocator(locatorKey: string): string {
    if (!locatorKey) {
      return '';
    }
    const entries = Array.isArray(this.elementEntryKeyData) ? this.elementEntryKeyData : [];
    const entry = entries.find((e: any) => e?.key === locatorKey);
    const raw = entry == null ? '' : String(entry.value || entry.locatorValue || '');
    const stripped = raw.replace(/^(NAME|ID|XPATH|UIAUTOMATION|CLASS|CSS|TAGNAME)\s*=\s*/i, '').trim();
    return stripped || locatorKey;
  }

  private ensureMenuClickLoaded() {
    if (!this.isMenuClick) {
      return;
    }
    if (this.menuClickLoadedIndex === this.testStepIndex) {
      return;
    }
    this.menuClickLoadedIndex = this.testStepIndex;
    this.loadMenuClickSelection(this.testStep?.[this.testStepIndex - 1]?.parameters?.settingValue || '');
  }

  syncMoveHighlightParams() {
    const step = this.testStep?.[this.testStepIndex - 1];
    if (!step) {
      return;
    }
    if (!step.parameters) {
      step.parameters = { settingValue: '', isMasked: false, owner: '', settingType: 'STANDARD', fieldType: '', values: [] };
    }
    step.parameters.settingValue = JSON.stringify({
      locator: this.moveHighlightLocator || '',
      currentRow: this.moveHighlightCurrentRow || '',
      currentColumn: this.moveHighlightCurrentColumn || '',
      verticalMove: this.moveHighlightVertical || 'NONE',
      verticalCount: this.moveHighlightVerticalCount || '1',
      horizontalMove: this.moveHighlightHorizontal || 'NONE',
      horizontalCount: this.moveHighlightHorizontalCount || '1'
    });
  }

  loadMoveHighlightSelection(settingValue: string) {
    this.moveHighlightLocator = '';
    this.moveHighlightCurrentRow = '';
    this.moveHighlightCurrentColumn = '';
    this.moveHighlightVertical = 'NONE';
    this.moveHighlightVerticalCount = '1';
    this.moveHighlightHorizontal = 'NONE';
    this.moveHighlightHorizontalCount = '1';
    if (!settingValue || !String(settingValue).trim()) {
      return;
    }
    try {
      const saved = JSON.parse(settingValue);
      this.moveHighlightLocator = saved?.locator || '';
      this.moveHighlightCurrentRow = saved?.currentRow != null ? String(saved.currentRow) : '';
      this.moveHighlightCurrentColumn = saved?.currentColumn != null ? String(saved.currentColumn) : '';
      this.moveHighlightVertical = saved?.verticalMove || 'NONE';
      this.moveHighlightVerticalCount = saved?.verticalCount != null && String(saved.verticalCount) !== ''
        ? String(saved.verticalCount) : '1';
      this.moveHighlightHorizontal = saved?.horizontalMove || 'NONE';
      this.moveHighlightHorizontalCount = saved?.horizontalCount != null && String(saved.horizontalCount) !== ''
        ? String(saved.horizontalCount) : '1';
    } catch {
      // leave defaults
    }
  }

  private ensureMoveHighlightLoaded() {
    if (!this.isMoveHighlight) {
      return;
    }
    if (this.moveHighlightLoadedIndex === this.testStepIndex) {
      return;
    }
    this.moveHighlightLoadedIndex = this.testStepIndex;
    this.loadMoveHighlightSelection(this.testStep?.[this.testStepIndex - 1]?.parameters?.settingValue || '');
  }

  keyArray(value) {
    this.selectedKeys = [];
    this.selectedKeys.push(value);
    this.testStep[this.testStepIndex - 1].parameters.settingValue = this.selectedKeys.toString()
    //console.log(this.selectedKeys);
  }
  onItemSelect1(item: any) {
    // this.selectedKeys=[];
    //console.log('onItemSelect', item);
    this.isER = true;
    this.selectedKeys1.push(item);
    console.log(this.testStep[this.testStepIndex - 1].parameters.settingValue)
    console.log(this.testStep[this.testStepIndex - 1]);
    console.log(this.selectedKeys.toString());
    //console.log(this.selectedKeys)
  }
  onItemSelect(item: any) {
    // this.selectedKeys=[];
    //console.log('onItemSelect', item);
    this.selectedKeys.push(item);
    this.testStep[this.testStepIndex - 1].parameters.settingValue = this.selectedKeys.toString()
    //console.log(this.selectedKeys)
  }
  onItemDeSelect(item: any) {
    var index = this.selectedKeys.indexOf(item);
    if (index !== -1) {
      this.selectedKeys.splice(index, 1);
    }
    //console.log(item);
    //console.log(this.selectedKeys);
    this.testStep[this.testStepIndex - 1].parameters.settingValue = this.selectedKeys.toString()
  }
  onItemDeSelect1(item: any) {
    var index = this.selectedKeys1.indexOf(item);
    if (index !== -1) {
      this.selectedKeys1.splice(index, 1);
    }
    //console.log(item);
    //console.log(this.selectedKeys);
    // this.testStep[this.testStepIndex - 1].parameters.settingValue = this.selectedKeys.toString()
  }
  onSelectAll(item: any) {
    //console.log('onSelectAll', item);
  }

  selectChangeScreen(event: any) {

    // //console.log("event : ",event);
    // //console.log(event.target.value);
    // //console.log(this.testStep);
    // //console.log(this.locatorData);
    this.selectedScreen = event;


    this.selectedScreen.substring(3);
    // //console.log('selectedScreen',this.selectedScreen);
    // this.getLocator();
    this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen); //imp
    // this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
    if(this.locatorData[0].locatorEntryMap==null){
      this.locatorData[0].locatorEntryMap = {entry:[]}
    }
    //console.log('elementKeyData', this.elementKeyData, this.selectedScreen)

    this.locatorId = this.elementKeyData[0].id;
    //console.log(this.locatorId);

    // new api
    if(!JSON.parse(localStorage.getItem('projectDataById'))){
      
    this.project.getProjectById(this.projectId).subscribe((
      data => {
        this.projectData = data;
        //console.log(this.projectData);
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
              //console.log(data);
            })
            this.locatorValueData = data;
            console.log(this.locatorValueData);
            if(this.locatorValueData.locatorEntryMap==null){
              this.locatorEntryMapValue = {entry:[]} ;
              this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
            }
            
            if(this.locatorValueData.locatorEntryMap!=null){
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //console.log(this.locatorEntryMapValue);
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap?.entry;
            this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
          }
          
        )
      }
    ))
    }
    else if(JSON.parse(localStorage.getItem('projectDataById'))){
      
      var res = JSON.parse(localStorage.getItem('projectDataById'));
          this.projectData = res;
          //console.log(this.projectData);
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
                //console.log(data);
              })
              this.locatorValueData = data;
            console.log(this.locatorValueData);
            if(this.locatorValueData.locatorEntryMap==null){
              this.locatorEntryMapValue = {entry:[]} ;
              this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
            }
            
            if(this.locatorValueData.locatorEntryMap!=null){
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //console.log(this.locatorEntryMapValue);
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap?.entry;
            this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
            }
          
          )
      
      }
    
    //console.log(this.elementEntryKeyData);
  }

  getElementKey(pageName) {
    //console.log(pageName);
    this.elementKeyData = this.locatorData.filter((s) => s.name === pageName); //imp
    //console.log('elementKeyData', this.elementKeyData, pageName)

    this.locatorId = this.elementKeyData[0].id;
    //console.log(this.locatorId);

    // new api
    // this.project.getProjectById(this.projectId).subscribe((
    //   data => {
    //     this.projectData = data;
    //     //console.log(this.projectData);
    //     this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
    //       (data) => {
    //         this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
    //           //console.log(data);
    //         })
    //         this.locatorValueData = data;
    //         //console.log(this.locatorValueData);
    //         // if(this.locatorValueData.locatorEntryMap==null){
    //         //   this.locatorEntryMapValue = {entry:[]} ;
    //         //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         // }
    //         // if(this.locatorValueData.locatorEntryMap!=null){
    //         //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         //   this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
    //         // }
    //         this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         //console.log(this.locatorEntryMapValue);
    //         this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
    //       }
    //     )
    //   }
    // ))

    this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
    //console.log(this.elementEntryKeyData);
  }
  loadElements(data) {



    this.selectedScreen = data
    //console.log('selectedScreen', this.selectedScreen);

    this.selectedScreen.substring(3);
    this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen); //imp
    if(this.elementKeyData[0].locatorEntryMap==null){
      this.elementKeyData[0].locatorEntryMap = {entry:[]}
    }
    //console.log('elementKeyData', this.elementKeyData, this.selectedScreen)

    this.locatorId = this.elementKeyData[0].id;
    //console.log(this.locatorId);

    // new api
    if(!JSON.parse(localStorage.getItem('projectDataById'))){
    this.project.getProjectById(this.projectId).subscribe((
      data => {
        this.projectData = data;
        //console.log(this.projectData);
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
              //console.log(data);
            })
            this.locatorValueData = data;
            //console.log(this.locatorValueData);
            // if(this.locatorValueData.locatorEntryMap==null){
            //   this.locatorEntryMapValue = {entry:[]} ;
            //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            // }
            // if(this.locatorValueData.locatorEntryMap!=null){
            //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //   this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            // }
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //console.log(this.locatorEntryMapValue);
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
          }
        )
      }
    ))
    }
   else if(JSON.parse(localStorage.getItem('projectDataById'))){
    var res = JSON.parse(localStorage.getItem('projectDataById'));
          this.projectData = res;
          //console.log(this.projectData);
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
                //console.log(data);
              })
              this.locatorValueData = data;
              //console.log(this.locatorValueData);
              // if(this.locatorValueData.locatorEntryMap==null){
              //   this.locatorEntryMapValue = {entry:[]} ;
              //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              // }
              // if(this.locatorValueData.locatorEntryMap!=null){
              //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              //   this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
              // }
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              //console.log(this.locatorEntryMapValue);
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
          )
       
      }
      
    this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
    //console.log(this.elementKeyData[0].locatorEntryMap.entry);
  }
  getAllProjectSetting = function () {
    this.testCase.getAllProjectSetting(this.projectId).subscribe(
      (data) => {
      console.log(data);

        if (data.projectSettingList) {
          const variables = [] as any;
          //  //console.log(data.projectSettingList.length);
          for (var i = 0; i < data.projectSettingList.length; i++) {
            if (data.projectSettingList[i].type === 'GLOBAL' || data.projectSettingList[i].name === 'cSetting') {
              for (var j = 0; j < data.projectSettingList[i].setting.entry.length; j++) {
                //   //console.log(data.projectSettingList[i].setting.entry.length);
                const tempData = data.projectSettingList[i].setting.entry[j];
                // //console.log("tempData", tempData);
                const temp = {
                  key: tempData.key,
                  variableType: data.projectSettingList[i].type
                };
                variables.push(tempData.key);
              }
            }
          }
          this.globalVariable = variables;
           console.log('global123',this.globalVariable);
        }

      }
    )
  }

  actionDesc(value){
      var des = this.actions.filter((a) => a.name === value);
      console.log('desc',des);
      
  }

  getActions = function () {
    if(this.projectType==undefined){
      this.projectType='MIXED';
    }
    this.testCase.getAction(this.projectType).subscribe(
      (data) => {
        this.actions=[];
        if (data && data.list && data.list.length !== this.actions.length) {
          for (var i = 0; i < data.list.length; i++) {
            if(typeof(data.list[i]) == 'string' && JSON.parse(data.list[i])){
            var obj = JSON.parse(data.list[i]);
            this.actions.push(obj);
            }
          }
          this.actions = _.chain(this.actions).sortBy('name').value();
          
        }
        this.getGroupedAction();
       
      });
  }
  loadFunction = function () {
if(JSON.parse(localStorage.getItem('functions'))){
  this.functions=JSON.parse(localStorage.getItem('functions'));
  console.log('tFunction',this.functions);
  this.functions.forEach(obj => {
    this.functionMethodNames[obj.method] = obj.method;
  });

  
}
else{
    if (this.functions.length === 0) {
      this.testCase.getFunction().subscribe((data) => {
        if (data && data.list && data.list.length !== this.functions.length) {
          for (var i = 0; i < data.list.length; i++) {
            var obj = JSON.parse(data.list[i]);
            this.functions.push(obj);
            this.functionMethodNames[obj.method] = obj.method;
            //  //console.log("", functionMethodNames[obj.method])
          }
        }
        this.functions = _.chain(this.functions).sortBy('name').value();
        console.log('function',this.functions);
        this.mapActionPse();
      });
    } else {
      return true;
    }
  }
}
  loadForms() {
    this.editLocatorTitleForm = this.formBuilder.group({
      name: ['',Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
    })

    this.addLocatorsForm = this.formBuilder.group({
      key: [''],
      value: [''],
      comment: ['']
    })
  }

  getLocator() {
    //console.log("inside service6 : ", this.projectId);
    //console.log(this.projectId);
    // if(JSON.parse(localStorage.getItem('locatorData'))){
    //   this.locatorData = JSON.parse(localStorage.getItem('locatorData'))
    // }
    // else{
      this.spinerFlag = true
      this.testCase.getLocatorSuite(this.projectId).subscribe(
        (data) => {
          //console.log("********", data)
          this.locatorData = data['locatorSuite'];
          this.spinerFlag = false
          try {
            if(this.locatorData){
              localStorage.removeItem('locatorData');
              localStorage.setItem('locatorData',JSON.stringify(this.locatorData));
            }
            
          } catch (error) {
            
          }
          //console.log(data);
          //console.log("locator data : ", this.locatorData);
        }
      )
    // }
   
  }
  getFuntionField(fieldList: string | any[], fieldName: string) {

    var feildName = [];
    for (let i = 0; i < fieldList.length; i++) {
      if (fieldList[i].visibleFieldValues.includes(fieldName)) {
        feildName[i] = fieldList[i].name;
      }
    }
    return feildName;
  }

  // editTestCaseTestSteps(){
  //   this.testCase.editTestCaseTestSteps().subscribe(
  //     (data)=>{
  //       //console.log('editTestCaseTestSteps>>',data)
  //     }
  //   );
  // }



  ngOnInit() {
    
    this.dropdownList = ["Option1", "2", "3", "4"];

    this.memoryService.getAgentCheck().subscribe(
      (response)=>{
        this.agentCheck = response;
      }
    )
    // this.editTestCaseTestSteps();
    this.route.paramMap.subscribe(
      params => {
        this.projectId = this.projectId;
        this.testId = this.parentId;
        this.testStepId = this.testStepId;
        this.testStepIndex = this.index;
        //console.log(this.projectId);
        this.getBranches(this.projectId,this.testId)
        this.getLocator();
       
        this.loadForms();
        if(!this.agentCheck){
          if(JSON.parse(localStorage.getItem('actions')) && this.pathCheck!='pre-condition'){
            this.actions=JSON.parse(localStorage.getItem('actions'));
           }
           else if(!JSON.parse(localStorage.getItem('actions')) || this.actions.length==0){
            this.getActions();
           }
           else if(this.pathCheck=='pre-condition'){

            this.getActions();
           
           }
        }
        else{
          this.memoryService.getActions().subscribe(
            (data)=>{
              this.actions=data;
            }
          )
        }
      
       
          this.loadFunction();
        this.getAllProjectSetting();
        if(!this.agentCheck){
          this.groupedActionData = JSON.parse(localStorage.getItem('groupedActionData'));
        }
        else{
          this.memoryService.getGroupedActionData().subscribe(
            (gData)=>{
              this.groupedActionData = gData;
            }
          )
        }

        if(this.pathCheck=='pre-condition'){
          this.testCase.getTestSuiteData(this.projectId,this.id).subscribe(
            (data)=>{
              this.suiteData = data;
              this.testStep = this.suiteData['teststepList']
              if(this.pseAction){
                this.actionsMetaData[this.testStep[this.testStepIndex-1].commandName] = this.pseAction;
              }
              this.getIncludedTestCases(this.projectId);
              //console.log('suiteData',this.testStep);
              //console.log(this.testStepIndex-1);
              //console.log(parseInt(this.testStepIndex)-1);
              //console.log('suiteStepData',this.testStep[this.testStepIndex-1]);
             
            }
          )
        }
        else {
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testData/' + this.projectId + '/' + this.testStepId).
          subscribe(
            (data) => {
              this.testStepdata = data['testCaseData'];

              console.log("TestStepData", this.testStepdata);
              this.testStep = [];
              this.testStep = this.testStepdata[0].teststepList;
              if(this.testStep[this.testStepIndex - 1]?.parameters?.settingValue.includes("extraction") || this.testStep[this.testStepIndex - 1]?.parameters?.settingValue.includes("redaction")){
              this.getRedactionDetails();
              }
              // this.loadActionsMetaData();
              // this.getGroupedAction()
              if(this.pseAction){
                this.actionsMetaData[this.testStep[this.testStepIndex-1].commandName] = this.pseAction;
              }
              
              this.getIncludedTestCases(this.projectId);
              
              //  this.loadFunction();
              
              // this.addNode(Tslength);
            }
          )
        
      }
      }

    );

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 5,
      allowSearchFilter: this.showFilter
    };


    
  }
  muFunction(name: string, value: number) {
    //console.log(name, value);

  }
  count=0

  getRedactionDetails() {
    this.userEmail = JSON.parse(localStorage.getItem('currentUser')).email;
    
    // Add error handling for localStorage
    if (!this.userEmail) {
      console.error('No user email found in localStorage');
      return;
    }
  
    this.redactionService.getRedactionFilters(this.erUrl, this.userEmail)
      .subscribe({
        next: (res) => {
          console.log('Response received:', res); // Debug log 1
          
          try {
            this.groupDetails = res;
  
            let extractionDetails = res['data']['Extraction'];
            let redactionDetails = res['data']['Redaction'];
  
            console.log('Extraction details:', extractionDetails); // Debug log 2
            console.log('Redaction details:', redactionDetails); // Debug log 3
  
            let extractionGroups: any = [];
            let redactionGroups: any = [];
  
            let extractionPII = {
              title: 'Personal Identifable Information',
              access: 'public',
              Entities: extractionDetails['Standard PII'],
              shared: []
            };
            extractionGroups.push(extractionPII);
            
            extractionDetails['Groups'].forEach(group => {
              let obj = {
                title: group.title,
                access: group.Access,
                Entities: group.Entities,
                shared: group.Shared
              };
              extractionGroups.push(obj);
            });
  
            console.log('Extraction groups processed:', extractionGroups); // Debug log 4
  
            let redactionPII = {
              title: 'Personal Identifable Information',
              access: 'public',
              Entities: redactionDetails['Standard PII'],
              shared: []
            };
            redactionGroups.push(redactionPII);
            
            redactionDetails['Groups'].forEach(group => {
              let obj = {
                title: group.title,
                access: group.Access,
                Entities: group.Entities,
                shared: group.Shared
              };
              redactionGroups.push(obj);
            });
  
            console.log('Redaction groups processed:', redactionGroups); // Debug log 5
  
            this.extractionTerms = extractionGroups;
            this.extractionTermsCopy = extractionGroups;
            this.redactionTerms = redactionGroups;
            this.redactionTermsCopy = redactionGroups; // Fixed this line
  
            console.log("Final values:", {
              extractionTerms: this.extractionTerms,
              redactionTerms: this.redactionTerms
            });

            this.extractionList = ['StandardPII', ...extractionDetails['Groups'].map(group => group.title)];

            // Create redaction list
            this.redactionList = ['StandardPII', ...redactionDetails['Groups'].map(group => group.title)];

            let currentValue = this.testStep[this.testStepIndex - 1].parameters['settingValue'];
            
            // Split the string by commas
            const parts = currentValue.split(',');
        
            // Extract the first three parts and rebuild the base string
            const baseString = parts.slice(0, 5).join(',') + ')'; // Ensures it ends correctly
        
            // Store everything after the first three parts in a separate array
            const remainingParts = parts.slice(5);
            // Only modify the last item in remainingParts (if it exists)
            if (remainingParts.length > 0) {
              remainingParts[remainingParts.length - 1] = remainingParts[remainingParts.length - 1].trim().replace(/[)}]/g, '');
            }

            // Directly assign remainingParts to selectedKeys2
            this.selectedKeys2 = remainingParts;

            console.log('Extraction/Redaction List:', this.extractionList);
            console.log('Selected Keys2:', this.selectedKeys2);
          
          } catch (error) {
            console.error('Error processing response:', error);
          }
        },
        error: (error) => {
          console.error('Error fetching redaction filters:', error);
        },
        complete: () => {
          console.log('Request completed');
        }
      });
  }

  onClickSubmit(testStepUpdateForm) {
    this.count += 1
    this.testStepAtSelectedIndex = this.testStep[this.testStepIndex - 1];
    this.testStepAtSelectedIndex['ERValue'] = this.selectedKeys1;
    //console.log("formTestStep", this.testStepAtSelectedIndex);
    // var cmd = this.testStepAtSelectedIndex.commandName
    //console.log("hello", testStepUpdateForm.value);
    this.arr = testStepUpdateForm.value;
    console.log("IT CAME HERE")
    console.log(testStepUpdateForm)
    console.log(this.arr)
    var FilterCommandName1 = this.actions.filter(f=>f.pseAction==this.arr.Action);
    console.log(FilterCommandName)
    console.log("FILTER COMMand")
    console.log(FilterCommandName1)
    if(this.count==1){  
    if(FilterCommandName1[0] ){
      this.arr.Action = FilterCommandName1[0].name;
      this.testStep[this.testStepIndex-1].commandName = this.arr.Action
      // FilterCommandName[0].pseAction =
    }
    else{
      //console.log('includes');
      this.toastrService.clear();
      this.toastrService.warning('Select command from the dropdown')
      return;
    }
   }
else{
  if(FilterCommandName1.length){
    var FilterCommandName = this.actions.filter(f=>f.pseAction==this.arr.Action);
  }
  else{
    var FilterCommandName = this.actions.filter(f=>f.name==this.arr.Action);
  }
 
    if(FilterCommandName[0] ){
      this.arr.Action = FilterCommandName[0].name;
      this.testStep[this.testStepIndex-1].commandName = this.arr.Action
      // FilterCommandName[0].pseAction =
    }
    else{
      //console.log('includes');
      this.toastrService.clear();
      this.toastrService.warning('Select command from the dropdown')
      return;
    }
}
    if (this.testStepAtSelectedIndex) {
      if (this.arr.actOptions) {
        this.testStepAtSelectedIndex.commandName = this.arr.actOptions;
        this.testStep[this.testStepIndex-1].commandName = this.arr.Action
      }
      else {
        this.testStepAtSelectedIndex.commandName = this.arr.Action;
        this.testStep[this.testStepIndex-1].commandName = this.arr.Action
        // this.actionsMetaData[this.arr.Action];

      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.pageName = this.arr.screenOptions;


        var testScreen = this.locatorData.filter((f)=> f.name==this.testStepAtSelectedIndex.pageName);
        //console.log(testScreen);
        if(this.testStepAtSelectedIndex.pageName && testScreen.length<1){
         
          this.toastrService.clear();
          this.toastrService.warning('Select valid name from the dropdown');
          return;
        }
      }
      else {
        this.testStepAtSelectedIndex.pageName = this.arr.Screen;
        var testScreen;
        if(this.locatorData)
        {
          testScreen = this.locatorData.filter((f)=> f.name==this.testStepAtSelectedIndex.pageName);
        }

        if(this.testStepAtSelectedIndex.pageName && testScreen && testScreen.length<1){
          
          this.toastrService.clear();
          this.toastrService.warning('Select valid name from the dropdown');
          return;
        }
      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.elementKey = this.arr.screenOptions;
      }
      console.log("UPDATED ARR")
      console.log(this.arr)
      if (!this.testStepAtSelectedIndex.parameters) {
        this.testStepAtSelectedIndex.parameters = { settingValue: '', isMasked: false, owner: '', settingType: 'STANDARD', fieldType: '', values: [] };
      }
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.arr.Parameter;
      if (this.testStep[this.testStepIndex - 1].commandName === 'STARTHIGHLIGHT') {
        this.syncStartHighlightParams();
        this.testStepAtSelectedIndex.parameters['settingValue'] =
          this.testStep[this.testStepIndex - 1].parameters.settingValue;
      } else if (this.testStep[this.testStepIndex - 1].commandName === 'MENUCLICK') {
        this.syncMenuClickParams();
        this.testStepAtSelectedIndex.parameters['settingValue'] =
          this.testStep[this.testStepIndex - 1].parameters.settingValue;
      } else if (this.testStep[this.testStepIndex - 1].commandName === 'MOVEHIGHLIGHT') {
        this.syncMoveHighlightParams();
        this.testStepAtSelectedIndex.parameters['settingValue'] =
          this.testStep[this.testStepIndex - 1].parameters.settingValue;
      } else if (this.testStep[this.testStepIndex - 1].commandName === 'CLEARHIGHLIGHT') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = '';
      } else if (this.testStep[this.testStepIndex - 1].commandName === 'WAIT'
          && this.isLeakedStartHighlightJson(this.testStepAtSelectedIndex.parameters['settingValue'])) {
        this.testStepAtSelectedIndex.parameters['settingValue'] = '';
      }
      // //console.log(this.selectedValue);
      console.log(this.testStepAtSelectedIndex)
      console.log(this.selectedValue)
      
      if (this.selectedValue === 'Text'
          && this.testStep[this.testStepIndex - 1].commandName !== 'STARTHIGHLIGHT'
          && this.testStep[this.testStepIndex - 1].commandName !== 'MENUCLICK'
          && this.testStep[this.testStepIndex - 1].commandName !== 'MOVEHIGHLIGHT'
          && this.testStep[this.testStepIndex - 1].commandName !== 'CLEARHIGHLIGHT') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.arr.Parameter;
      }
      if (this.selectedAction === 'SEND_KEYS' || this.arr.Action=='SEND_KEYS') {
        if(this.selectedKeys.length){
          this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedKeys.toString() + '&';
        }
        else{
          this.testStepAtSelectedIndex.parameters['settingValue'] = this.arr.Parameter;
        }
       
      }
      if (this.selectedAction === 'INVOKETEST' || this.arr.Action=='INVOKETEST' || this.selectedAction === 'RUN_STEP_BATCH' || this.selectedAction === 'RUNTESTDATA') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedCaseId + '&' + this.selectedCase[0].execuationIteration;
        //console.log(this.testStepAtSelectedIndex.parameters);

      }
      if (this.selectedAction === 'HITL' || this.arr.Action=='HITL') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedBranches.join();
        //console.log(this.testStepAtSelectedIndex.parameters);

      }
      if (this.selectedAction === 'SET_BUG_LOG_DATA') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = JSON.stringify(this.parameterForLogData);
      }
      if (this.selectedValue === 'Global Variable') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = '$G{' + this.arr.globalValue + '}';

      }

      if (this.selectedValue === 'Function') {
        //console.log(this.arr);
        var functionValue = _.omit(this.arr, ['Action', 'actOptions', 'Screen', 'screenOptions', 'Element', 'elementKey']);
        //console.log(functionValue);

        const myArray = Object.values(functionValue);
        //console.log(myArray);

        // this.testStepAtSelectedIndex.parameters = '${__' + this.contentDiv[index]['methodname'] + '(' + myArray + ')' + '}';
      }
      if (!this.selectedValue) {
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.testStepAtSelectedIndex.parameters['settingValue'];
      }
      if (this.contentDiv) {
        //console.log(this.contentDiv);

        var paramName = '';
        for (let i = 0; i < this.contentDiv.length; i++) {

          if (this.contentDiv[i].parameterType == 'Text') {
            paramName = paramName + this.contentDiv[i].parameterValue;

          }
          if (this.contentDiv[i].parameterType == 'Global Variable') {
            paramName = paramName + '$G{' + this.contentDiv[i].parameterValue + '}';
          }

          if (this.contentDiv[i].parameterType == 'Function') {//isKeyValueFunction//isKeyValueFunction
            //console.log(this.contentDiv[i]['methodname']);
            if(this.keyValueFunctions.includes(this.contentDiv[i]['methodname']) || this.contentDiv[i]['isKeyValueFunction']){
              let result = [];
              var warningMessage = '';
              this.contentDiv[i]['fieldlist'].forEach(data => {
                 //console.log(data);

                 if(data.isEditable==false && data.value==undefined){
                   data.value=data.defaultValues[0];
                 }
                 if(data.isMandatory==true && data.name !=='custom-groups'){
                  // if(this.selectedSubfunction && data.isMandatory==true && data.isFieldDecideable==true){
                  //   data.value = this.selectedSubfunction
                  // }
                  if(data.value==undefined || data.value==''){
                    warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                  }

                 }
                 if(data.isMandatory==false){
                  if(data.value==undefined || data.value==''){
                    data.value=' ';
                    //console.log(data);

                  }

                 }
                

                let result1 = data.name + "=" + data.value;
                console.log("THE DATA IS" + result1)
                result.push(result1);



               });

               if (warningMessage && warningMessage.length > 0) {
                // warningMessage = $scope.toCamelCase(warningMessage);
                 this.toastrService.clear();
                 this.toastrService.warning(warningMessage, null, {
                     enableHtml: true
                 });
              return;
             }
               let finalValue = result.join();
                 paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
                 //console.log(paramName);
                 if(this.contentDiv[i]['result4']){
                  //console.log(this.contentDiv[i]['result4']);
                  let varResult = []
                  for(let j =0; j<this.contentDiv[i]['result4'].length;j++){
                    this.contentDiv[i]['result4'][j].forEach(data1 => {

                      let varResult1 = data1.value;

                      varResult.push(varResult1);

                    });
                  }

                 //console.log(varResult);

                  let finaleValueOfVarFunc = varResult.join(',');

                  //console.log(finaleValueOfVarFunc);

                  //console.log('final',finaleValueOfVarFunc);


                    paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue +','+ finaleValueOfVarFunc + ')}';
                }
            }
            else{
              let result = [];
              var warningMessage = '';
              this.contentDiv[i]['fieldlist'].forEach(data => {
                 //console.log(data);

                 if(data.isEditable==false && data.value==undefined){
                   data.value=data.defaultValues[0];
                 }

                if(data.isMandatory==true && data.name !=='custom-groups'){
                 if(data.value==undefined || data.value==''){
                   warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                 }

                }
                if(data.isMandatory==false || data.value==''){
                  if(data.value==undefined){
                    data.value=' ';
                    //console.log(data);

                  }

                 }

                 let result1 = data.value;
                 result.push(result1);

               });
               if (warningMessage && warningMessage.length > 0) {
                // warningMessage = $scope.toCamelCase(warningMessage);
                 this.toastrService.clear();
                 this.toastrService.warning(warningMessage, null, {
                     enableHtml: true
                 });
              return;
             }
               let finalValue = result.join();
                 paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
                 //console.log(paramName);
                 if(this.contentDiv[i]['result4']){
                  //console.log(this.contentDiv[i]['result4'][i]);
                  let varResult = []
                  for(let j =0; j<this.contentDiv[i]['result4'].length;j++){
                    this.contentDiv[i]['result4'][j].forEach(data1 => {
                      if(data1.value!=undefined){
                      let varResult1 = data1.value;
                      varResult.push(varResult1);
                      }
                    });
                  }
                  let finaleValueOfVarFunc = varResult.join(',');
                  console.log('final',finaleValueOfVarFunc);


                    paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue +','+ finaleValueOfVarFunc + ')}';
                }
            }


              // //console.log(this.contentDiv[i]['parameterArg']);
              // if (this.contentDiv[i]['parameterArg']) {
              //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
              //   //console.log('result1', this.contentDiv[i]['result1']);

              //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
              //   if (!this.contentDiv[i]['isKeyValueFunction']) {
              //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
              //   }

              // }
              // else {
              //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
              //   //console.log('result1', this.contentDiv[i]['result1']);
              //   if (!this.contentDiv[i]['isKeyValueFunction']) {
              //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
              //   }
              // }

              // if (this.contentDiv[i]['isKeyValueFunction']) {
              //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
              //     this.contentDiv[i]['result2'].forEach((value, index2) => {
              //       //console.log(index1, index2)
              //       if (index1 == index2) {
              //         let obj = { 'name': element, 'value': value }
              //         if(!this.contentDiv[i]['result3'])
              //         {
              //           this.contentDiv[i]['result3'] = [];
              //           this.contentDiv[i]['result3'].push(obj);
              //         }
              //         this.contentDiv[i]['result3'].push(obj);
              //       }
              //     });
              //   });

              //   let result = [];
              //   this.contentDiv[i]['result3'].forEach(data => {
              //     let result1 = data.name + "=" + data.value;
              //     result.push(result1);
              //   });

                // let finalValue = result.join();
                // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
                // //console.log(paramName);



            // else {

            // //console.log(this.contentDiv[i].parameterValue);

            //   let result = [];
            //   this.contentDiv[i]['fieldlist'].forEach(data => {
            //     let result1 = data.value;
            //     result.push(result1);
            //   });
            //   let finalValue = result.join();
            //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //     //console.log(paramName);

            //   // //console.log(this.contentDiv[i]['parameterArg']);
            //   // if (this.contentDiv[i]['parameterArg']) {
            //   //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
            //   //   //console.log('result1', this.contentDiv[i]['result1']);

            //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
            //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
            //   //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
            //   //   }

            //   // }
            //   // else {
            //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
            //   //   //console.log('result1', this.contentDiv[i]['result1']);
            //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
            //   //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
            //   //   }
            //   // }

            //   // if (this.contentDiv[i]['isKeyValueFunction']) {
            //   //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
            //   //     this.contentDiv[i]['result2'].forEach((value, index2) => {
            //   //       //console.log(index1, index2)
            //   //       if (index1 == index2) {
            //   //         let obj = { 'name': element, 'value': value }
            //   //         if(!this.contentDiv[i]['result3'])
            //   //         {
            //   //           this.contentDiv[i]['result3'] = [];
            //   //           this.contentDiv[i]['result3'].push(obj);
            //   //         }
            //   //         this.contentDiv[i]['result3'].push(obj);
            //   //       }
            //   //     });
            //   //   });

            //   //   let result = [];
            //   //   this.contentDiv[i]['result3'].forEach(data => {
            //   //     let result1 = data.name + "=" + data.value;
            //   //     result.push(result1);
            //   //   });

            //     // let finalValue = result.join();
            //     // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //     // //console.log(paramName);
            //     if(this.contentDiv[i]['result4']){
            //     //console.log(this.contentDiv[i]['result4'][i]);
            //     let varResult = []
            //     this.contentDiv[i]['result4'][i].forEach(data1 => {

            //       let varResult1 = data1.name + "=" + data1.value;
            //       varResult.push(varResult1);
            //     });
            //     let finaleValueOfVarFunc = varResult.join();
            //     //console.log('final',finaleValueOfVarFunc);


            //       paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue +','+ finaleValueOfVarFunc + ')}';
            //   }


            // }

            // }

          }




        }


        // //console.log("final result3");


        if (this.contentDiv[0]['parameterType'] != undefined
            && this.testStep[this.testStepIndex - 1].commandName !== 'STARTHIGHLIGHT'
            && this.testStep[this.testStepIndex - 1].commandName !== 'MENUCLICK'
            && this.testStep[this.testStepIndex - 1].commandName !== 'MOVEHIGHLIGHT'
            && this.testStep[this.testStepIndex - 1].commandName !== 'CLEARHIGHLIGHT') {
          //console.log(this.contentDiv);

          this.testStepAtSelectedIndex.parameters['settingValue'] = paramName;
        }

        //console.log('param', paramName);

      }

      if (this.testStep[this.testStepIndex - 1].commandName === 'STARTHIGHLIGHT') {
        this.syncStartHighlightParams();
        this.testStepAtSelectedIndex.parameters['settingValue'] =
          this.testStep[this.testStepIndex - 1].parameters.settingValue;
      } else if (this.testStep[this.testStepIndex - 1].commandName === 'MENUCLICK') {
        this.syncMenuClickParams();
        this.testStepAtSelectedIndex.parameters['settingValue'] =
          this.testStep[this.testStepIndex - 1].parameters.settingValue;
      } else if (this.testStep[this.testStepIndex - 1].commandName === 'MOVEHIGHLIGHT') {
        this.syncMoveHighlightParams();
        this.testStepAtSelectedIndex.parameters['settingValue'] =
          this.testStep[this.testStepIndex - 1].parameters.settingValue;
      } else if (this.testStep[this.testStepIndex - 1].commandName === 'CLEARHIGHLIGHT') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = '';
      }

      this.testStepAtSelectedIndex.elementKey = this.arr.Element;
      // this.testStepAtSelectedIndex.commandName = this.selectedAction;


      //console.log(">>", this.testStepAtSelectedIndex);
    }
    // {"Action":"BACK","Screen":"","Element":"locator7","visa,master,amex,discover,enroute,jcb,voyager,diners":"visa","Number of digits":"78","Count of card numbers":"87","true,false":"false"}
if(this.pathCheck=='pre-condition'){
this.updatePreTestSteps();
}
else{
  console.log("IT CAME HERE")
  if(this.selectedFunction == 'Extraction' || this.selectedFunction == 'Redaction'){
    this.isER = true;
  }
  if(this.isER){
  let currentValue = this.testStep[this.testStepIndex - 1].parameters['settingValue'];
  const parts = currentValue.split(',');
  const lastCommaIndex = currentValue.lastIndexOf(',', currentValue.lastIndexOf(')}'));
  const baseString = parts.slice(0, 5).join(',') + ',';
  console.log(baseString);
  console.log(this.selectedKeys2.toString());
  const newValue = baseString + this.selectedKeys2.toString() + ')}';
  console.log(newValue);
  this.testStep[this.testStepIndex - 1].parameters.settingValue = newValue;
  this.isER = false;
  }
  this.updateTestSteps();
}


  
this.showPopUp = false;}
  // apply() {
  //   this.result = this.questions;
  //   this.close();
  // }

  getIncludedTestCases(projectId) {//localStorage.setItem('includedTestCase',JSON.stringify(this.allTestCaseData))
    if(!JSON.parse(localStorage.getItem('includedTestCase'))){
      this.testCase.getIncludedTestCases(projectId).subscribe(
        (data) => {
  
          this.allTestCaseData = data['testCaseData'];

          this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f?.id != this.testStepId && f?.branch[0]==="false");
    //       if(!this.filterAllTesCaseData || this.filterAllTesCaseData.length==0){  
    // return ;
    // }
          //console.log('include', this.allTestCaseData);
          //console.log('filter>', this.filterAllTesCaseData);
          //console.log('data', this.testStep[this.testStepIndex - 1].parameters);
          if (this.testStep[this.testStepIndex - 1].commandName == 'INVOKETEST' && this.filterAllTesCaseData?.length > 0) {
            this.selectedTestCase = this.testStep[this.testStepIndex - 1].parameters['settingValue'].substr(0, this.testStep[this.testStepIndex - 1].parameters['settingValue'].indexOf('&'));
            //console.log('selectedId', this.selectedTestCase);
            if (this.selectedTestCase) {
              this.onChange(this.selectedTestCase, true)
            }
          }
        
        }
      )
    }
    else if(JSON.parse(localStorage.getItem('includedTestCase'))){
     
      this.allTestCaseData = JSON.parse(localStorage.getItem('includedTestCase'));
      this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f?.id != this.testStepId && f?.branch[0]==="false");
      //console.log('include', this.allTestCaseData);
      //console.log('filter>', this.filterAllTesCaseData);
      //console.log('data', this.testStep[this.testStepIndex - 1].parameters);
      if (this.testStep[this.testStepIndex - 1].commandName == 'INVOKETEST'  && this.filterAllTesCaseData?.length > 0) {
        this.selectedTestCase = this.testStep[this.testStepIndex - 1].parameters['settingValue'].substr(0, this.testStep[this.testStepIndex - 1].parameters['settingValue'].indexOf('&'));
        //console.log('selectedId', this.selectedTestCase);
        if (this.selectedTestCase) {
          this.onChange(this.selectedTestCase, true)
        }
      }
    }
   
  }
  getBranches(projectId,testSuiteId){
    this.testCase.getBranchList(projectId,testSuiteId).subscribe(
     (data)=>{
       this.allBranches = data;
       console.log(this.allBranches);
       
     }
    )
   }

    onChange(id: string, isChecked: boolean,testCaseData?:any) {
      // console.log(testCaseData);
      if (isChecked) {
        //console.log(id);
        this.selectedCaseId = id;
        this.selectedCase = this.filterAllTesCaseData.filter((f => f.id == id))
        //console.log(this.selectedCase);
        if(this.selectedCase && this.selectedCase?.length>0){
        
        this.moduleName = this.selectedCase[0].path.split(',');
        }
        else{
          this.moduleName = [];
        }
      }
      if(testCaseData){
      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + testCaseData.parentTestDataId+ '/' + id).
          subscribe(
            (data) => {
              if(data['teststepList']){
             var allSteps:any = data['teststepList'];
             var findHItlSteps  = allSteps.find((f)=>f.commandName=='HITL')
             if(findHItlSteps){
              this.toastrService.clear();
              this.toastrService.warning('This case contains HITL steps, can not include this case');
              isChecked=false
              return;
             }
             else{
              
             }
            }
            else{
              this.toastrService.clear();
              this.toastrService.warning('This case does not contains any steps, can not include this case');
              isChecked=false
              return;
            }
            })
      }
   
        }

 
  indexFormArray: UntypedFormArray;
  onselectCase(index: any, isChecked: boolean) {
 if(true){

  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;
 
  if (isChecked) {

    this.indexFormArray.push(new UntypedFormControl(index));
    
    ////this.indexFormArray.value);
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == index)
    this.indexFormArray.removeAt(Index);
  
 }
 this.selectedBranches = this.indexFormArray.value
 console.log('branchData',this.selectedBranches,this.indexFormArray);
 
    ////this.indexFormArray.value)
  }

}
  filterArr() {
    //console.log(this.testStep.length);
    this.initiateDelTestStep = this.testStep;
    for (var i = 0; i < this.initiateDelTestStep.length; i++) {

      if (this.initiateDelTestStep[i] === this.stepsTobeDelete) {

        this.initiateDelTestStep.splice(i, 1);
      }

    }
    //console.log(this.initiateDelTestStep);
  }
  updateTestSteps() {

    if (this.testStep?.[this.testStepIndex - 1]?.commandName === 'STARTHIGHLIGHT') {
      this.syncStartHighlightParams();
    } else if (this.testStep?.[this.testStepIndex - 1]?.commandName === 'MENUCLICK') {
      this.syncMenuClickParams();
    } else if (this.testStep?.[this.testStepIndex - 1]?.commandName === 'MOVEHIGHLIGHT') {
      this.syncMoveHighlightParams();
    }
    // this.stepIndex = 3;
    this.projectId;
    //console.log(this.projectId);
    //console.log(this.testStepId);
    const updateTestStepData = this.testStepdata[0];
    console.log(updateTestStepData);
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
    console.log(myFinalObject);
    for (let i = 0; i < updateTestStepData.teststepList.length; i++) {
      // this.testStep[i] = {
      //    stepIndex:''
      //   }
      this.testStep[i].stepIndex = i;
      //console.log(this.testStep);
      if (this.testStep[i].commandName == 'UNKNOWN') {
        //console.log(i);
        this.stepsTobeDelete = this.testStep[i];
        this.filterArr();
        // this.toastrService.clear();
        // this.toastrService.success( ' Can not add unknown command');

      }
    }
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', myFinalObject).
      subscribe((data) => {
        if (data) {
          //console.log("upDateData", data);
          this.dialogRef.close(true);
        }
      });
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
  close() {
    // this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);

  }
  goBack() {
    // window.history.back();
    this.location.back();
  }
  show() {
    this.hide = !this.hide;
  }
  refreshPage() {
    this.document.defaultView.location.reload();
  }

  changeTab(isElementKey: boolean, screenName: string) {

    this.editLocatorTitleForm.reset();
    //console.log("tab changed");
    this.currentTab = 1;
    //console.log('currentTab', this.currentTab, 'isElementKey', isElementKey, 'screenName', screenName);
    this.selectedScreenName = screenName;
    this.showElementKeyContnent = isElementKey;
    if (this.showElementKeyContnent) {
      this.editLocatorTitleForm.patchValue({ name: screenName })
    }
    // this.screenName = screenName;
    //console.log(this.locatorData);
  }

  enableSubmitF(value) {
    if (this.testStep[this.testStepIndex - 1].pageName != value) {
      this.enableSubmit = true;
    }
    else {
      this.enableSubmit = false;
    }
  }

  tab(val) {
    this.tabVal = val;
  }

  onCreateScreen() {

    
    if (this.editLocatorTitleForm.invalid) {
      return;
    }
    var objFormval = this.editLocatorTitleForm.value;
    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }
    var Objval = {
      name: objFormval.name,
      projectId: this.projectId
    }
    //console.log(Objval);
    // var cancelObj = this.cancelmodal;
    this.project.addScreen(Objval).subscribe((data) => {
      if (data) {
        //console.log('add Screen Data', data);

        this.currentTab = 0;
        localStorage.removeItem('locatorData');
        this.getLocator();

        // this.locatorData.push(data.name);
        this.toastrService.clear();
        this.toastrService.success(' New screen added successfully');

        // //console.log("Locator data",data);
        // this.refreshPage();
        this.project.sendLocatorData(this.projectId);

      }

    });

  }

  addLocators() {
    this.addLocator = true;
    this.disableButton = false;
    this.locatorValueIndex = undefined;
    this.updateLocatorValues = false;
    this.addLocatorsForm.reset();
  }

  revertForm() {
    this.addLocator = false;
    this.disableButton = true;
    this.addLocatorsForm.reset();
  }

  insertComment(key) {
    this.keyForinsertComment = key;
    this.valueForInsert = this.locatorEntryCommentValue.filter((f) => f.key == this.keyForinsertComment);
    this.valueForUpdate = this.valueForInsert[0].value;
    if (this.valueForUpdate == undefined) {
      this.valueForUpdate = 'Enter Comment'
    }
  }

  delLocator(values) {
    this.confirmationDialogService.openConfirmDialog('Are you sure to delete ' + values + ' ?')
      .afterClosed().subscribe(res => {
        if (res) {
          const valueForDelete = this.locatorEntryMapValue.filter((f) => f.key == values);

          this.locatorEntryMapValue.forEach((element, index) => {
            if (element == valueForDelete[0]) this.locatorEntryMapValue.splice(index, 1);
          });
          var functionValue = _.omit(this.locatorValueData, ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited', 'path']);
          //console.log(functionValue);
          this.spinerFlag=true
          this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
            (data) => {
              this.spinerFlag=false;
              this.toastrService.clear();
              this.toastrService.success(' locator deleted succesfully');
              this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
                (data) => {
                  this.locatorValueData = data;
                  this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
                  this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
                  //console.log(this.locatorEntryMapValue);
                  //console.log(this.locatorValueData);
                  this.addLocatorsForm.reset();
                }
              )
            }
          )
        }
      }

      )
    // //console.log(this.locatorValueData);
  }

  updateLocator(index, rowData) {
    this.addLocator = false;
    this.disableButton = true;
    //console.log("update locator", rowData)
    this.updateLocatorValues = true;
    this.locatorValueIndex = index;
    //console.log(this.locatorValueIndex);
    this.addLocatorsForm.patchValue({ 'key': rowData.key, 'value': rowData.value });
  }


  revertLocatorForm() {
    this.locatorValueIndex = undefined;
    this.updateLocatorValues = false;
    this.addLocatorsForm.reset();
  }

  submitLocatorForm() {
    //console.log(this.addLocatorsForm.value, "submitted");
    //console.log(this.selectedScreen);

    if (this.addLocatorsForm.invalid) {
      return;
    }
    this.addLocatorsForm.value.key = this.addLocatorsForm.value.key.trim();
    this.addLocatorsForm.value.value = this.addLocatorsForm.value.value.trim();
    var objFormval = this.addLocatorsForm.value;

    //console.log(objFormval, this.locatorData);

    let screenNameData = this.locatorData.filter((data) => data.name == this.selectedScreen)
    //console.log(screenNameData)
    screenNameData[0].locatorEntryMap.entry[this.locatorValueIndex] = objFormval;
    //console.log(screenNameData[0]);
    var functionValue = _.omit(screenNameData[0], ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited', 'path']);
    const compareKeyValue = functionValue.locatorEntryMap.entry.filter((f) => f.key == objFormval.key);
    //console.log(compareKeyValue);
    if (compareKeyValue[1]) {
      this.toastrService.clear();
      this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
      return;
    }
    //console.log(functionValue);
    this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
      (data) => {
        //console.log('locator submited', data);

        this.closeDialog();
        this.toastrService.clear();
        this.toastrService.success('Locator data updated succesfully');
        //  this.locatorValueData = data;
      })

  }

  onUpdateLocator() {

  }


  onAddLocators() {
    //console.log(this.addLocatorsForm.value);

    this.disableButton = true;
    if (this.addLocatorsForm.invalid) {
      return;
    }
this.addLocatorsForm.value.key = this.addLocatorsForm.value.key.trim()
this.addLocatorsForm.value.value = this.addLocatorsForm.value.value.trim()
    var objFormval1 = this.addLocatorsForm.value;
    console.log(objFormval1);
    if (this.locatorEntryMapValue) {

      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      //console.log('hero')
      const objForCommentMap =
      {
        key: objFormval1.key,
        value: objFormval1.comment
      }

      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Values Are Not Allowed ');
        return;
      }
      const compareKeyValue = this.locatorValueData.locatorEntryMap.entry.filter((f) => f.key == objForCommentMap.key);
      if (compareKeyValue[0]) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
        return;
      }
      this.locatorEntryMapValue.unshift(objFormval1);
      if(this.locatorValueData.locatorCommentMap)
      {
        this.locatorValueData.locatorCommentMap.entry.unshift(objForCommentMap);
      }
      else
      {
        let data =
        {
          entry : []
        }
        data.entry.push(objForCommentMap);
        this.locatorValueData.locatorCommentMap = data;
      }
      this.spinerFlag=true
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data) => {
          // //console.log('locator save data',);
          // var d = data['locatorSuite'][0].name;
          this.spinerFlag=false;
          this.loadElements(this.selectedScreenName);
          // this.selectChangeScreen(data['locatorSuite'][0].name)

          this.getLocator();
          this.addLocator = false;
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          this.addLocatorsForm.reset();
        }
      )
    }
    else {
      //console.log('null');
      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        //console.log('Empty key Are Not Allowed');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Value Are Not Allowed ');
        //console.log('Empty Value Are Not Allowed');

        return;
      }
      if (objFormval1.comment == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Comment Are Not Allowed ');
        //console.log('Empty comment Are Not Allowed');
        return;
      }
      this.locatorEntryMapValue = { entry: [] };
      this.locatorValueData.locatorCommentMap = {
        entry: [
          {
            key: objFormval1.key,
            value: objFormval1.comment
          }
        ]
      }
      this.locatorEntryMapValue.entry.unshift(objFormval1);

      this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data) => {

          this.addLocator = false;
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              this.locatorValueData = data;
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
              //console.log(this.locatorEntryMapValue);
              //console.log(this.locatorValueData);
              this.getLocator();
              this.addLocatorsForm.reset();
            }
          )
        }
      )
    }

  }
  getIterationValue(captureIteration) {
    //console.log('>>', captureIteration.value);

  }
  submitBugForm(formLog) {
    //console.log(formLog.value);
    var keyArray = Object.keys(formLog.value);
    var valueArray = Object.values(formLog.value)
    //console.log(keyArray);
    //console.log(Object.values(formLog.value));
    var objForUpdate = {
      key: "",
      value: "",
    }
    var objArray = []
    for (let i = 0; i < keyArray.length; i++) {

      objArray.push(objForUpdate);

    }
    // var objectForupdateparameter=[{
    //   key:Object.keys(formLog.value),
    //   value:Object.values(formLog.value)
    // }]
    //console.log(objArray);

    var objArrayClone = JSON.parse(JSON.stringify(objArray))
    for (let i = 0; i < objArrayClone.length; i++) {
      //console.log(keyArray[i]);
      //console.log(objArrayClone[i].key);

      objArrayClone[i].key = keyArray[i];
      objArrayClone[i].value = valueArray[i];
    }
    //console.log(objArrayClone);
    this.parameterForLogData = objArrayClone;
    this.bugButton.nativeElement.click()
  }
  getAllSetting() {//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/project/getAllProjectSettings/61276c94a1f486a24017af5e
    this.http.get(this.url + '/HuLoopRest/huloop/project/getAllProjectSettings/' + this.projectId).subscribe(
      (data) => {
        this.settingData = data['projectSettingList'];
        this.testEnvData = this.settingData.filter((f) => f.name == 'envSetting')
      }
    )
  }


onChangeFunctionDropdown(value, name, isFieldDecideable,index,defaultValues?:any) {
  //console.log('insideDropDown');
  console.log('defaultValues',defaultValues,value, name, isFieldDecideable);
  // if(defaultValues){
  //   var description = defaultValues.filter((f) => f.name ===value);
  //   console.log('description',description[0].description);
  //   this.functionDescription = description[0].description;
  // }else{
  //   this.functionDescription = ''
  // }
 
  // this.testStepAtSelectedIndex['functionDescription'] = this.functionDescription;
  
    //TODO: need to change this hack
    if (!isFieldDecideable) {
        return;
    }
    if (name === 'overwrite' && this.currentFunction.name === 'FILEHANDLER') {
        return;
    }
    if (name === 'track' && this.currentFunction.name === 'FILEHANDLER') {
        return;
    }


    // this.currentFunction.fieldList = this.contentDiv[index]['fieldlist'];
    var matchingElements = this.getMatchingFields(JSON.parse(JSON.stringify(this.currentFunction.fieldList)), name);
    //var matchingElements = this.currentFunction.fieldList.filter(o => o.visibleFieldName === name);
    var matchingValues = [];
    if (matchingElements.length > 0) {
        matchingValues = this.getMatchingValues(matchingElements, value);
        console.log(matchingValues);

        matchingValues.splice(0, 0, this.getFuntionField1(this.currentFunction.fieldList, name));// Add the current field at index 0
        this.contentDiv[index]['fieldlist'] = matchingValues;
        //console.log(this.contentDiv[index]['fieldlist']);
        JSON.parse(JSON.stringify(this.currentFunction.fieldList))
        // if ($scope.testStepObj.parametersForms) {
        //     $scope.testStepObj.parametersForms[0].args = new Array();
        //     $scope.testStepObj.parametersForms[0].args.push(value);
        // }
        // $scope.onSelectionChanges($scope.testStepObj);
    }
    if (this.currentFunction.type === 'variable' && this.currentFunction.variableFieldList && this.currentFunction.variableFieldList.length > 0) {
        // this.currentFunction.variableFieldList = angular.copy($scope.originalVaribaleFieldList);
        var matchingElements = [];
        for (var i = 0; i < this.currentFunction.variableFieldList.length; i++) {
            if (this.currentFunction.variableFieldList[i].visibleFieldName === name) {
                if (this.currentFunction.variableFieldList[i].visibleFieldValues.includes(value)) {
                    this.currentFunction.variableFieldList[i].isVisible = true;
                    matchingElements.push(this.currentFunction.variableFieldList[i]);
                }
            }
        }
        this.currentFunction.variableFieldList = matchingElements;
    }

};


getMatchingFields (fieldList, fieldName) {
  var matchingElements = [];
  for (var i = 0; i < fieldList.length; i++) {
      if (fieldList[i].visibleFieldName === fieldName) {
          matchingElements.push(fieldList[i]);
      }
  }
  return matchingElements;
}

getMatchingValues (matchingElements, value) {
  var matchingValues = [];
  for (var i = 0; i < matchingElements.length; i++) {
      if (matchingElements[i].visibleFieldValues.includes(value)) {
          matchingElements[i].isVisible = true;
          matchingValues.push(matchingElements[i]);
      }
  }
  return matchingValues;
}

getFuntionField1(fieldList, fieldName) {
  var matchingField;
  for (var i = 0; i < fieldList.length; i++) {
      if (fieldList[i].name === fieldName) {
          matchingField = fieldList[i];
          break;
      }
  }
  return matchingField;

}

checkIfFunctionMethodNameExist (methodName) {
  if (this.functionMethodNames[methodName]) {
      return true;
  }
  return false;
}

replaceNth(str, n, newChar) {
  const arr = str.split(',');
  return arr.map((item, i) => (i % n === 0) ? item.replace(',', newChar) : item).join(",")
}


updatePreTestSteps() {

  // this.stepIndex = 3;
  this.projectId;
  //console.log(this.projectId);

  const updateTestStepData = this.testStep;
  //console.log(updateTestStepData);
  var objForUpdate=
  {
id:this.id,
projectId:this.projectId,
teststepList:updateTestStepData
  }

  this.testCase.editTestFileStep(objForUpdate).subscribe((data)=>{
    //console.log(data);
    this.dialogRef.close(true);
  }
  )

  // this.testCase.editTestFileStep()
  // const myObject = updateTestStepData[0];
  // var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
  // //console.log(myFinalObject);
  // this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', myFinalObject).
  //   subscribe((data) => {
  //     if (data) {
  //       //console.log("upDateData", data);

  //     }
  //   });
}

showCommandName(command, param?:string) {
   this.showPopUp = true
    return this.actionsMetaData[command];
    
}

loadActionsMetaData() {
  return this.groupedActionData.forEach(groupedActionItem => {
    groupedActionItem.children.forEach(action => {
      if (action.type == 'action') {
        this.actionsMetaData[action.children.name] = action.name;
      } else if (action.type == 'fun') {
        this.actionsMetaData[action.function.name] = action.name;
      } else if (action.type == 'sub') {
        this.actionsMetaData[action.subfunction[0].children.name] = action.name;
        // action.subfunction[0]
        // action.subfunction.forEach(subfunction => {
        //   this.actionsMetaData[subfunction.children.name] = subfunction.name;
        // });
      }
    });
    this.mapActionPse();
    this.actionsMetaData['OPEN'] = 'Open Web Browser';
    return;
  });
}

getGroupedAction() {
  return this.testCase.getGroupedAction().subscribe(
    (data) => {
      this.groupedActionData = data;
      this.groupedActionData.forEach(groupedActionItem => {
        groupedActionItem.children.forEach(action => {
          if (action.type == 'action') {
            this.actionsMetaData[action?.children?.name] = action?.name;
          } else if (action.type == 'fun') {
            this.actionsMetaData[action?.function?.name] = action?.name;
          } else if (action.type == 'sub') {
            this.actionsMetaData[action?.subfunction[0]?.children?.name] = action?.name;
            // action.subfunction[0]
            // action.subfunction.forEach(subfunction => {
            //   this.actionsMetaData[subfunction.children.name] = subfunction.name;
            // });
          }
        });
      });
        this.mapActionPse();
      return;
    }
  )
}
mapActionPse(){
  this.actions.forEach(element => {
    if(this.actionsMetaData[element.name]){
    element['pseAction']=this.actionsMetaData[element.name]
    }
    else{
      element['pseAction'] = element.name
    }
  });
  this.functions.forEach(functionPse => {
    if(this.actionsMetaData[functionPse.name]){
      functionPse['pseFunction']=this.actionsMetaData[functionPse.name]
    }
    else{
      functionPse['pseFunction'] = functionPse.name;
    }
    
  });
 
  console.log('gFun', this.functions);
  if(this.pathCheck=='pre-condition' && this.buttonAction=='Edit')
    {
      this.pseAction = this.actionsMetaData[this.pseAction];
    }
}
}